import { defaultTelosProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/telos/default-constants';

export const OMNIDEX_CONTRACT_ADDRESS = '0xF9678db1CE83f6f51E5df348E2Cc842Ca51EfEc1';

export const OMNIDEX_PROVIDER_CONFIGURATION = defaultTelosProviderConfiguration;
